import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "企业名称", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "纳税人类型", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "tr" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "纳税人识别号", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "证件号码", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "tr" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "经营地点", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "欠税税种", -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "tr" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "当前新发生的欠税余额", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "发布单位", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "tr" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "发布日期", -1)
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "欠税余额", -1)
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "tr" }
const _hoisted_38 = { class: "item" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "欠税人信息", -1)
const _hoisted_40 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.d.companyName || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.d.type || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.d.identifyNo || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.d.idNo || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.d.addr || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.d.category || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.d.newBal?_ctx.d.newBal+'元':'-'), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.d.issuedBy || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.toDate(_ctx.d.publishDate,"YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.d.balance?_ctx.d.balance+'元':'-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.d.oper?_ctx.d.oper.name:'-'), 1)
      ])
    ])
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}